module.exports = [{"id":1,"title":"л.с."},{"id":0,"title":"кВт"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/powerUnits.json
// module id = 495
// module chunks = 49